// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".study-remove{color:#666666;font-size:1.3rem;cursor:pointer}.study-remove:hover{color:#333333}.study-remove:active{color:#F9405A}\n", ""]);
// Exports
module.exports = exports;
